module.exports = __webpack_public_path__ + "img/binding_width.de801e5a.png";